import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';;
import {InsolesModel} from './insoles.model';
import {InsolesSummaryConverter} from './insolesSummary.converter';
import {InsoleDataSummaryConverter} from "./data/insoleDataSummary.converter";
import {SubscriptionConverter} from "../../../../subscription/api/entity/converter/subscription.converter";
import {InsolesProviderModelSummaryModel} from "../../../provider/model/api/entity/insolesProviderModelSummary.model";
import {
    InsolesProviderModelSummaryConverter
} from "../../../provider/model/api/entity/insolesProviderModelSummary.converter";
import {InsolesProviderModelConverter} from "../../../provider/model/api/entity/insolesProviderModel.converter";
import {InsoleDataConverter} from "./data/insoleData.converter";
import {Scan3dGroupSummaryConverter} from "../../../scan3d/scanGroup/api/entity/converter/scan3dGroupSummary.converter";
import {
    ProviderServiceOptionSummaryConverter
} from "../../../../provider/service/option/api/entity/converter/providerServiceOptionSummary.converter";

@Injectable()
export class InsolesConverter extends HttpModelConverter<InsolesModel> {

    constructor(private insolesSummaryConverter: InsolesSummaryConverter,
                private insoleDataConverter: InsoleDataConverter,
                private scanGroupSummaryConverter: Scan3dGroupSummaryConverter,
                private optionConverter: ProviderServiceOptionSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesModel {
        return new InsolesModel();
    }

    protected enrichObject(result: InsolesModel, src: InsolesModel) {
        result.summary = this.insolesSummaryConverter.convert(src.summary);
        result.leftData = this.insoleDataConverter.convert(src.leftData);
        result.rightData = this.insoleDataConverter.convert(src.rightData);
        result.scanGroup = this.scanGroupSummaryConverter.convert(src.scanGroup);
        result.options = this.optionConverter.convertFromArray(src.options);
    }

}
